import AddAsAppModal from './AddAsAppModal';

export default AddAsAppModal;
